
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("bCOF9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;
// ====================================================================================
// a11y module
// ====================================================================================
var $639f39d5df6033bb$var$init = module.exports.init = function init() {
    var attempts = 0;
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") document.querySelectorAll(".powermail_submit").forEach(function(el) {
            el.addEventListener("keydown", function(e) {
                if (e.key === "Enter" || e.key === " ") e.target.click();
            });
        });
        else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=a11y.46ad498f.js.map
